/**
 * 作用：所有API组件
 * 作者：闫聪洋
 * 时间：2018-04-18
 */

import axios from 'axios'
//上传二维码
export const reqWxencode = params => { return axios.put('agency2/wxencode', params) };

/**
 * 登录账号/解锁
 */
export const reqLogin = params => { return axios.post('auth/logout', params).then(res => res.data) };

/**
 * 获取用户信息
 */
export const reqUserInfo = params => { return axios.get('authenticate/credentials', { params: params }) };
/**
 * 重置密码
 */
export const reqResetPassword = params => { return axios.put("/password/initial/", params) };

/**
 * 获取园所列表、 增  、改、  删
 */
export const reqList = params => { return axios.get("/n_serviceUnit/join", { params: params }) };
export const reqAdd = params => { return axios.post("/n_serviceUnit/create", params) };
export const reqEdit = params => { return axios.put("/n_serviceUnit/modify", params) };
export const reqDel = params => { return axios.get("/n_serviceUnit/delete", { params: params }) };
//幼儿园首页
export const reqKdgInfo = params => { return axios.get("/n_serviceUnit/kg/home", { params: params }) };//管理员、机构、代理：首页
export const reqKdgInfoNew = params => { return axios.get("/n_serviceUnit/kg/home2", { params: params }) };//园所身份：首页
export const reqHomeClassList = params => { return axios.get("/n_serviceUnit/kg/homeClass", { params: params }) };//侧边栏导航
export const reqHomeClassMemberTest = params => { return axios.get("/n_serviceUnit/kg/classMemberTest", { params: params }) };//侧边栏导航


//幼儿园数据核查
export const reqKdgTestCheck = params => { return axios.get('/N_Physical/GetPhysicalTest', { params: params }) };
//获取幼儿园体侧信息（园所报告）
export const reqKdgTestInfo = params => { return axios.post('/serviceUnitExport/serviceUnitAbstractA', params) };
// 超出加盟商服务地区验证
export const reqAddressCheck = params => { return axios.get("/n_serviceUnit/check", { params: params }) };

/**
 * 获取加盟商列表、 增  、改、  删(同园所一样)
 */

//加盟商首页
export const reqAllianceInfo = params => { return axios.get("/n_serviceUnit/alliance/homeInfo", { params: params }) };
//加盟商历史测试
export const reqAllianceHistory = params => { return axios.get('/n_testHistory', { params: params }) };

/**
 * 获取加盟商——园所沟通列表、 增  、改、  删
 */
export const reqMarketList = params => { return axios.get("/N_Market/GetProject", { params: params }) };
export const reqMarketAdd = params => { return axios.post("/N_Market/CreateProject", params) };
export const reqMarketEdit = params => { return axios.put("/N_Market/UpdataProject", params) };
export const reqMarketDel = params => { return axios.post("/N_Market/DeleteProject", params) };
//加盟商——项目信息、日志列表、 增  、改、  删
export const reqLogList = params => { return axios.get("/N_Market/Log", { params: params }) };
export const reqLogAdd = params => { return axios.post("/N_Market/Log", params) };
export const reqLogEdit = params => { return axios.put("/N_Market/Log", params) };
//资源联系人
export const reqContactList = params => { return axios.get("/N_Market/GetResourceContact", { params: params }) };
export const reqContactAdd = params => { return axios.post("/N_Market/CreateResourceContact", params) };
export const reqContactEdit = params => { return axios.put("/N_Market/UpdateResourceContact", params) };
export const reqContactDel = params => { return axios.post("/N_Market/DeleteResourceContact", params) };
//师资列表
export const reqTeacherList = params => { return axios.get("/N_Market/Teacher", { params: params }) };
export const reqTeacherAdd = params => { return axios.post("/N_Market/Teacher", params) };
export const reqTeacherEdit = params => { return axios.put("/N_Market/Teacher", params) };
export const reqTeacherDel = params => { return axios.delete("/N_Market/Teacher", { params: params }) };
/**
 * 获取机构列表、 增  、改、  删(同园所一样)
 */

//机构/代理首页
export const reqAgencyProxyInfo = params => { return axios.get("/n_serviceUnit/agencyProxy/homeInfo", { params: params }) };

/**
 * 获取代理列表、 增  、改、  删(同园所一样)
 * 代理首页(同机构一样)
 */

/**
 * 获取班级列表、 增  、改、  删
 */
export const reqClassList = params => { return axios.get("/serviceUnitClass/classList", { params: params }) };
export const reqClassAdd = params => { return axios.post("/serviceUnitClass/createClass", params) };
export const reqClassEdit = params => { return axios.put("/serviceUnitClass/updateClass", params) };
export const reqClassDel = params => { return axios.put("/serviceUnitClass/deleteClass", params) };

/**
 * 获取孩子列表、 增  、改、  删
 */
export const reqChildList = params => { return axios.get("/n_child/childList", { params: params }) };
export const reqChildAdd = params => { return axios.post("/n_child/create", params) };
export const reqChildEdit = params => { return axios.put("/n_child/update", params) };
export const reqChildDel = params => { return axios.put("/n_child/delete", params) };
//classId==" "
export const reqALLChildList = params => { return axios.get('/serviceUnitChild/childList', { params: params }) };
//classId!=" "
export const reqItemChildList = params => { return axios.get("/n_child", { params: params }) };

/*
*机构/代理：测试员管理
*增  、改、  删
*/
export const reqTestTeacherList = params => { return axios.get("/serviceUnit/miniProgramTeacherList", { params: params }) };
export const reqTestTeacherAdd = params => { return axios.post("rc_teacher/createTeacher", params) };
export const reqTestTeacherEdit = params => { return axios.post("rc_teacher/updateTeacher", params) };
export const reqTestTeacherDel = params => { return axios.post("rc_teacher/delete", params) };



/**
 * 导出
 */

//  埋点
export const reqBurialPoint = params => { return axios.get('/log/function', { params: params }) };

//日志信息
export const reqLogInformationPost = params => { return axios.post('/N_Market/Log', params) };
export const reqLogInformationPut = params => { return axios.put('/N_Market/Log', params) };
export const reqLogInformationGet = params => { return axios.get('/N_Market/Log', { params: params }) };

//体格锻炼计划课程
export const reqCouresCustomizedGet = params => { return axios.get('/course/customized', { params: params }) };
export const reqCouresLibrary = params => { return axios.get('/course/library', { params: params }) };
export const reqCouresintelligence = params => { return axios.get('/course/intelligence', { params: params }) };
export const reqCouresCustomizedPost = params => { return axios.post('/course/customized', params) };

//导出报告
export const reqExportFamilyReportA = params => { return axios.post('/serviceUnitExport/serviceUnitFamilyReportA', params) };
export const reqExportImprovePlan = params => { return axios.get('/serviceUnitExport/improvePlan', { params: params }) };
export const reqExportRecord = params => { return axios.get('/serviceUnitExport/exportRecord', { params: params }) };
export const reqExportAbstract = params => { return axios.post('/serviceUnitExport/serviceUnitAbstractA', params) };
export const reqExportInfoGet = params => { return axios.get('/N_Physical/GetExportInfo', { params: params }) };

//家长报告
export const reqExportResultInfo = params => { return axios.get('/export/FullChildResultInfo', { params: params }) };

//幼儿园首页
export const reqKindergartenHomeGet = params => { return axios.get('/n_serviceUnit/Kg/home2', { params: params }) };

//幼儿筛选
export const reqScreenChildrenClass = params => { return axios.get('/serviceUnitClass/classList', { params: params }) };
export const reqScreenChildrenSearch = params => { return axios.get('/N_Physical/ChildSearch', { params: params }) };

//教师管理
export const reqCheckAccount = params => { return axios.get('/user/checkAccount', { params: params }) };
export const reqCreateTeacher = params => { return axios.post('/rc_teacher/createTeacher', params) };
export const reqUpdateTeacher = params => { return axios.post('/rc_teacher/updateTeacher', params) };
export const reqDeleteTeacher = params => { return axios.post('/rc_teacher/delete', params) };
export const reqTeachingCase = params => { return axios.get('/course/teachingcase', { params: params }) };////课程内容

//其他
export const reqUserAuth = params => { return axios.put('/users/userAuth', params) };//用户解锁

//师训包,课程包
export const reqPostCourseTraining = params => { return axios.post('/contents/packages', params) };
export const reqGetCourseTrainingList = params => { return axios.get('/contents/packages', { params: params }) };
export const reqDeleteCourseTraining = params => { return axios.delete('/contents/packages', { params: params }) };
export const reqPackageCourseStatus = params => { return axios.post('/contents/packagesStatus', params) };
export const reqPostCourseKangaroo = params => { return axios.post('/courses/kangaroo', params) };

//课程
export const reqGetCourse = params => { return axios.get('/courses', { params: params }) };
export const reqPostCourse = params => { return axios.post('/courses', params) };
export const reqDeleteCourse = params => { return axios.delete('/courses', { params: params }) };
export const reqGetCourseInfo = params => { return axios.get('/courses/info', { params: params }) };
export const reqGetCourseListInfo = params => { return axios.get('/courses/package/info', { params: params }) };
export const reqGetCourseInfoKangaroo = params => { return axios.get('/courses/kangarooCourseInfo', { params: params }) };
export const reqPostCopyCourseKangaroo = params => { return axios.post('/courses/kangarooCopyCourse', params) };


//师训
export const reqGetTraining = params => { return axios.get('/trainings', { params: params }) };
export const reqPostTraining = params => { return axios.post('/trainings', params) };
export const reqDeleteTraining = params => { return axios.delete('/trainings', { params: params }) };
export const reqGetTrainingInfo = params => { return axios.get('/trainings/info', { params: params }) };

//预约活动
export const reqActivityList = params => { return axios.get('/activities', { params: params }) }




// WEBPACK FOOTER //
// ./src/api/api.js